// array manipulation function
export function removeItemFromArray<T>(array: T[], condition: (item: T) => boolean): T[] {
  const index = array.findIndex(condition);
  if (index >= 0) {
    array.splice(index, 1);
  } else {
    /* eslint-disable-next-line no-console */
    console.error('Item not found in array');
  }
  return array;
}

/* comparison function */
export const getAddedElement = <T>(original: T[], latest: T[]): T[] => {
  return latest.filter((item) => !original.includes(item));
};

export const getRemovedElement = <T>(original: T[], latest: T[]): T[] => {
  return original.filter((item) => !latest.includes(item));
};

// doesnt care if they are in different order, just same content
export const arrayEqual = <T>(original: T[], latest: T[]): boolean => {
  if (original.length !== latest.length) {
    return false;
  }
  const added = getAddedElement(original, latest);
  if (added.length > 0) {
    return false;
  }
  const removed = getRemovedElement(original, latest);
  if (removed.length > 0) {
    return false;
  }
  return true;
};
